var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.5727 30.0312V17.4375H8.25V11.625H12.5727V7.56592C12.5727 3.14433 15.3719 0.96875 19.3163 0.96875C21.2057 0.96875 22.8295 1.10942 23.3027 1.17229V5.79311L20.5671 5.79435C18.4219 5.79435 17.9375 6.8137 17.9375 8.30952V11.625H23.75L21.8125 17.4375H17.9375V30.0312H12.5727Z","fill":"#4D437D"}));
}

Facebook.defaultProps = {"width":"32","height":"31","viewBox":"0 0 32 31","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
